import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "styled-components";

// import "react-progress-2/main.css";

// import "react-s-alert/dist/s-alert-css-effects/jelly.css";

// import "react-dropdown/style.css";

// import "./styles/styles.scss";
import "react-select/dist/react-select.min.css";
import "style-loader/lib/addStyles";
import "css-loader/lib/css-base";

import AppRouter from "./routers/AppRouter";
import configureStore from "./store/configureStore";

import ThemeContainer from "./themes/Container";
import darkTheme from "./themes/darkTheme";
import lightTheme from "./themes/lightTheme";
import { errorNotification } from "./_services/application/errorNotification";

// import {API_KEY} from './constants/stripeConstants';
// import ReactGA from 'react-ga';

const store = configureStore();


const ErrorComponent = () => {
  return <div style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    fontSize: "18px",
  }}> <h1 style={{fontSize:"18px"}}>Sorry, something went wrong. Please try again, or refresh the page.</h1></div>;
};

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: { message: "", stack: "" },
    info: { componentStack: "" }
  };

  static getDerivedStateFromError = error => {
    return { hasError: true };
  };

  sendNotification = async (error, info) => {
    try{
      let token = await localStorage.getItem("token");
     let results = await errorNotification(token, { 
       payload: {
         error: error.message,
         pageUrl: window.location.href,
         componentStack: info.componentStack,
         stack: error.stack,
       }
      });

    } catch(err){
      console.log(err);
    }
  }

  componentDidCatch = (error, info) => {
    this.setState({ error, info });
    this.sendNotification(error, info);
  };

  render() {
    const { hasError, error, info } = this.state;
    const { children } = this.props;

    return hasError ? <ErrorComponent /> : children;
  }
}

const App = () => {
  const stored = localStorage.getItem("isDarkMode");
  const [isDarkMode, setIsDarkMode] = useState(
    stored === "true" ? true : false,
  );

  return (
    <ErrorBoundary>
    <Provider store={store}>
      <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
        <ThemeContainer>
           <AppRouter />
        </ThemeContainer>
      </ThemeProvider>
    </Provider>
    </ErrorBoundary>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));
